import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileFullname.css';

const ProfileFullname: React.FC = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('Dayo');
  const [lastName, setLastName] = useState('Odewade');

  const handleSave = () => {
    // Handle save logic here
    console.log('Saving:', { firstName, lastName });
    // Navigate back after save
    navigate('/profile-security');
  };

  return (
    <div className="profile-fullname-container">
      {/* Header */}
      <div className="profile-fullname-header">
        <button className="profile-fullname-back-button" onClick={() => navigate('/profile-security')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="profile-fullname-header-title">Full Name</h1>
      </div>

      {/* Form Content */}
      <div className="profile-fullname-content">
        {/* First Name Field */}
        <div className="profile-fullname-field">
          <label className="profile-fullname-label">First name</label>
          <div className="profile-fullname-input-wrapper">
            <input
              type="text"
              className="profile-fullname-input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Enter first name"
            />
          </div>
        </div>

        {/* Last Name Field */}
        <div className="profile-fullname-field">
          <label className="profile-fullname-label">Last name</label>
          <div className="profile-fullname-input-wrapper">
            <input
              type="text"
              className="profile-fullname-input"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Enter last name"
            />
          </div>
        </div>

        {/* Save Button */}
        <button className="profile-fullname-save-button" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default ProfileFullname;